import React from 'react';
import styled from 'styled-components';

import AggregateCheckBox from '../../containers/users/AggregateCheckBox';
import UsersTemplateDrawerMenu from '../../containers/users/UsersTemplateDrawerMenu';
import UsersTableView from '../table/UsersTableView';
import UsersColumns from './UsersColumns';
import UsersHeader from './UsersHeader';
import UsersFilter from '../../containers/users/UsersFilter';
import EventSelector from './EventSelector';
import NavigationBar from '../navigation/NavigationBar';
import SpinnerWithButton from '../common/SpinnerWithButton';

const UsersViewContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: calc(100% - 63px);

  .sub-container {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
    width: 100%;

    .main {
      border-right: 1px solid rgb(224, 224, 224);
      padding: 20px;
      width: 430px;
      overflow: auto;
      flex-shrink: 0;

      .main-content {
        margin: 0 0 15px 0;
      }
    }
  }
`;

const StyledTableView = styled(UsersTableView)`
  .full-height {
    height: 100%;
  }
`;

const UsersView = ({
  tableConfig,
  metainf,
  columns,
  executing,
  setUsersEventColumnValue,
  deleteUsersEventColumn,
  addUsersEventColumn,
  event,
  events,
  changeUsersEvent,
  onExecute,
  executeDisabled,
  extraActions,
  onRequestCancel,
  cancelButtonDisabled,
}) => (
  <>
    <NavigationBar
      onExecute={onExecute}
      executeDisabled={executeDisabled || executing}
      extraActions={extraActions}
    />
    <UsersViewContainer>
      <div className="st-users-view">
        <SpinnerWithButton
          onClick={onRequestCancel}
          disabled={cancelButtonDisabled}
          executing={executing}
        >
          <div className="sub-container">
            <div className="main">
              <div className="main-content">
                <UsersHeader />
                <EventSelector event={event} changeUsersEvent={changeUsersEvent} events={events} />
                {event ? (
                  <div>
                    <UsersFilter />
                  </div>
                ) : undefined}
              </div>
              <div>
                <UsersColumns
                  columns={columns}
                  setUsersEventColumnValue={setUsersEventColumnValue}
                  metainf={metainf}
                  deleteUsersEventColumn={deleteUsersEventColumn}
                  addUsersEventColumn={addUsersEventColumn}
                />
              </div>
              <AggregateCheckBox />
            </div>
            <StyledTableView paddingWidth={57} tableConfig={tableConfig} />
          </div>
        </SpinnerWithButton>
      </div>
      <UsersTemplateDrawerMenu />
    </UsersViewContainer>
  </>
);

export default UsersView;
